import { XMarkIcon } from "@heroicons/react/24/outline";
import * as Dialog from "@radix-ui/react-dialog";
import { Button } from "./Button";

export const DeleteDialogModal = ({
    open,
    setOpen,
    handleDelete,
    disabled,
    message = "This action cannot be undone. This will permanently delete this record.",
}: {
    open: boolean;
    setOpen: (isOpen: boolean) => void;
    handleDelete: () => void;
    disabled: boolean;
    message?: string;
}) => {
    return (
        <Dialog.Root open={open} onOpenChange={setOpen}>
            <Dialog.Portal>
                <Dialog.Overlay className="fixed inset-0 z-50 bg-black/40" />
                <Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-full max-w-xs -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-lg shadow-lg">
                    <div className="">
                        <Dialog.Close asChild>
                            <button className="absolute top-2 right-2 rounded-full p-1 text-gray-600 transition-transform duration-150 hover:text-black focus:outline-none focus:ring-0">
                                <XMarkIcon className="h-5 w-5" />
                            </button>
                        </Dialog.Close>
                    </div>

                    <div className="space-y-4 bg-white p-4">
                        <p className="text-lg font-semibold text-gray-800">Are you sure?</p>
                        <p className="text-sm text-gray-600">{message}</p>

                        <div className="flex justify-start gap-2">
                            <button
                                type="button"
                                className="rounded bg-red-600 px-4 py-1.5 text-sm font-medium text-white hover:bg-red-700"
                                onClick={() => {
                                    handleDelete();
                                }}
                                disabled={disabled}
                            >
                                Delete
                            </button>
                            <Dialog.Close asChild>
                                <button className="rounded bg-gray-100 px-4 py-1.5 text-sm font-medium text-gray-800 hover:bg-gray-200">
                                    Cancel
                                </button>
                            </Dialog.Close>
                        </div>
                    </div>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};
